import {Model, View} from "@lernetz/ts-lib";
import template from "./Toggle.html"

export class ToggleView extends View {
    constructor() {
        super({ template })
    }
}

export class Toggle extends Model {
    constructor(dto) {
        super(dto);
    }
}
